import { Route, Routes } from '@angular/router';
import { publicRoutes } from './public/public.routes';
import { secureRoutes } from './secure/secure.routes';
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'secure',
  },
  ...secureRoutes,
  ...publicRoutes,
];
